// Which form tab (Edit) / step (Create) owns each field, so a failed validation can jump to
// the right place. Kept free of React so it can be unit-tested.

export const TABS = { PERSONAL: 'personal', BILLING: 'billing' };

const PERSONAL_KEYS = ['username', 'email', 'phoneNo', 'countryCode'];

// Error keys are field names ('username') or dotted plan paths ('pricingPlan.baseCharge').
// Anything that is not a personal field belongs to Pricing & Billing.
export function fieldToTab(key) {
  return PERSONAL_KEYS.includes(key) ? TABS.PERSONAL : TABS.BILLING;
}

function activeKeys(errors) {
  return Object.keys(errors || {}).filter((key) => errors[key]);
}

// Personal wins over Billing: it is the first tab/step, so the user is walked through in order.
export function firstTabWithError(errors) {
  const keys = activeKeys(errors);
  if (keys.some((key) => fieldToTab(key) === TABS.PERSONAL)) return TABS.PERSONAL;
  if (keys.length > 0) return TABS.BILLING;
  return null;
}

// First invalid key (in the errors object's insertion order) inside `tab`; any tab when omitted.
export function firstErrorKey(errors, tab) {
  return activeKeys(errors).find((key) => !tab || fieldToTab(key) === tab) || null;
}

export function errorsByTab(errors) {
  const keys = activeKeys(errors);
  return {
    [TABS.PERSONAL]: keys.some((key) => fieldToTab(key) === TABS.PERSONAL),
    [TABS.BILLING]: keys.some((key) => fieldToTab(key) === TABS.BILLING),
  };
}

// Call right after switching tab/step: the target input only exists once that pane has
// rendered, so the focus is deferred one frame. A ref to an unmounted input is null, and a
// third-party input (PhoneInput) may hand back something without focus(), so both are guarded.
export function focusField(inputRefs, key) {
  if (!key) return;
  const run = () => {
    const el = inputRefs && inputRefs.current ? inputRefs.current[key] : null;
    if (el && typeof el.focus === 'function') {
      el.focus();
      if (typeof el.scrollIntoView === 'function') el.scrollIntoView({ block: 'center' });
    }
  };
  if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
  else setTimeout(run, 0);
}
